export const REGEX_FULLNAME = /^[A-Za-zก-๙\s]{2,50}$/;
export const REGEX_TEL_HOME_MOBILE = /^(0[456789]{1}[0-9]{8}|0[0-9]{8})$/;
export const REGEX_TEL_MOBILE = /^(0[689]{1}[0-9]{8})$/;
export const REGEX_LINE_ID = /^[@A-Za-z0-9._-]{1,20}$/;
export const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_BRANCH_CODE = /^[0-9]*$/;

export const REGEX_ONLY_NUMBER = /^[0-9]*$/;

export const REGEX_BASE_64 = /^data:image\/[a-zA-Z]+;base64,/;

export const REGEX_NO_SPECIAL_CHARACTERS = /^[a-zA-Z\u0E00-\u0E7F0-9\s]*$/;

export const REGEX_CHARACTERS_SPACE = /^[A-Za-zก-๙\s]*$/;
